import { RetirementDropSource } from "web_myplann/Inspiration/Retirement/constants";
import type {
	RetirementManualDrop,
	RetirementUncheckedDrop,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { getRetirementDropTiming } from "web_myplann/Inspiration/Retirement/Utils/getRetirementDropTiming";

export const mapRetirementManualDrop = (
	extra: RetirementManualDrop,
	retirementYear: number,
): RetirementUncheckedDrop => ({
	id: extra.id,
	label: { type: RetirementDropSource.Manual, kind: extra.kind },
	amount: extra.amount,
	...getRetirementDropTiming(extra.endYear, retirementYear),
});
